export default from './SteppedBuyerRegistrationForm';



// WEBPACK FOOTER //
// ./src/sharedComponents/SteppedBuyerRegistrationForm/index.js